import React, { useState, useEffect } from "react";
import { Slider, Typography } from "@mui/material";

type Props = {
    value: number | null;
    onChange: (val: number) => void;
};

const TradeLockFilter: React.FC<Props> = ({ value, onChange }) => {
    const [localValue, setLocalValue] = useState(value);

    // Sync when external state changes
    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    // Do not render if value is null
    if (value === null) {
        return null;
    }

    return (
        <div>
            <Typography className="text-gray-300 !text-[0.80rem] !font-semibold mb-1">
                Trade Lock (Days)
            </Typography>

            <Slider
                value={localValue ?? 0}
                min={0}
                max={7}
                step={1}
                marks={[
                    { value: 0, label: "0" },
                    { value: 1, label: "1" },
                    { value: 2, label: "2" },
                    { value: 3, label: "3" },
                    { value: 4, label: "4" },
                    { value: 5, label: "5" },
                    { value: 6, label: "6" },
                    { value: 7, label: "7" },
                ]}
                onChange={(_, v) => setLocalValue(v as number)}
                onChangeCommitted={(_, v) => onChange(v as number)}
            />
        </div>
    );
};

export default TradeLockFilter;